import Cookies from 'js-cookie';

import { COOKIES } from '@libs/core';

import { getDecisions } from './parseDecisions';

export function isAuth0Enabled(): boolean {
    return getDecisions({ raw: Cookies.get(COOKIES.X_PETM_DECISIONS) }).auth0 === true;
}
